export default __webpack_public_path__ + "static/media/104.e855709c.svg";